<template>
    <div>
        <b-modal
            id="bundleCalendarDateModal"
            v-model="showModal"
            size="lg"
            modal-class="modal-gg"
            hide-footer
            centered
        >
            <div class="w-100" slot="modal-header">
                <h3 v-if="bundleData" class="modal-title">
                    <small>{{ formattedDayOfWeek }}</small>
                    {{ formattedDayOfMonth }}
                    <span v-if="bundleData.schedule_date" class="event-name">
                        {{ bundleData.schedule_date.name }}
                    </span>
                </h3>
                <button type="button" class="close" data-dismiss="modal" @click="closeModal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div v-if="isLoading" class="text-center p-4">
                <i class="fal fa-spinner fa-spin fa-2x"></i>
            </div>

            <div v-if="bundleData && !isLoading">
                <div class="bundle-errors">
                    <div v-if="hasInsufficientUnits" class="alert alert-info my-1 d-flex">
                        <div class="d-flex align-items-center">
                            <i class="fal fa-exclamation-triangle fa-fw"></i>
                        </div>
                        <div class="ml-3">
                            Only assets where the units available are greater than or equal to the units per bundle will
                            be included in the bundle on this date.
                        </div>
                    </div>
                </div>

                <div class="card card-gg">
                    <table class="table table-gg">
                        <thead>
                        <tr>
                            <td>Asset Name</td>
                            <td>Category</td>
                            <td>Online Unit Price</td>
                            <td>Units Available</td>
                            <td>Units Per Bundle</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="bundleAsset in bundleData.bundle_assets" :key="bundleAsset.id">
                            <td>{{ bundleAsset.name }}</td>
                            <td>{{ bundleAsset.category.name }}</td>
                            <td>{{ formatMoney(bundleAsset.price) }}</td>
                            <td>
                                {{ bundleAsset.units_available }}
                                <span v-if="isUnitsInsufficient(bundleAsset)" class="ml-2">
                                        <i class="text-info fal fa-exclamation-triangle fa-fw"></i>
                                    </span>
                            </td>
                            <td>{{ bundleAsset.units_per_bundle }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import moment from 'moment';
import { money } from '@jgile/laravel-vue/resources/js/util';

export default {
    data() {
        return {
            showModal: false,
            isLoading: false,
            bundleData: null,
            bundleUnits: null,
            startDate: null,
            assetId: null,
        };
    },
    computed: {
        formattedDayOfWeek() {
            return this.startDate ? moment(this.startDate).format('dddd') : '';
        },
        formattedDayOfMonth() {
            return this.startDate ? moment(this.startDate).format('D') : '';
        },
        hasInsufficientUnits() {
            if (!this.bundleData || !this.bundleData.bundle_assets) {
                return false;
            }
            return this.bundleData.bundle_assets.some(bundleAsset =>
                this.isUnitsInsufficient(bundleAsset),
            );
        },
    },
    methods: {
        openModal(payload) {
            this.bundleUnits = payload.bundle_units;
            this.startDate = payload.start_date;
            this.assetId = payload.asset_id;
            this.showModal = true;
            this.fetchBundleData();
        },
        closeModal() {
            this.showModal = false;
            this.bundleData = null;
            this.bundleUnits = null;
            this.startDate = null;
            this.assetId = null;
        },
        fetchBundleData() {
            if (!this.assetId || !this.startDate) {
                return;
            }

            this.isLoading = true;

            const params = new URLSearchParams();
            params.append('start_date', this.startDate.format('YYYY-MM-DD'));

            // Convert bundle_units object to Laravel array format
            Object.entries(this.bundleUnits).forEach(([key, value]) => {
                params.append(`bundle_units[${key}]`, value);
            });

            axios.get(`/api/team/bundles/${this.assetId}/date-details?${params.toString()}`).then(response => {
                this.bundleData = response.data.data;
            }).catch(error => {
                console.error('Error fetching bundle data:', error);
                this.$noty.error('Failed to load bundle details');
                this.closeModal();
            }).finally(() => {
                this.isLoading = false;
            });
        },
        formatMoney(amount) {
            if (!amount && amount !== 0) {
                return '$0.00';
            }

            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            }).format(amount);
        },
        isUnitsInsufficient(bundleAsset) {
            if (!this.bundleUnits) {
                return false;
            }
            const requiredUnits = this.bundleUnits[bundleAsset.id];
            return bundleAsset.units_available < requiredUnits;
        },
    },
    mounted() {
        Bus.$on('openBundleCalendarDateModal', (event) => {
            if (event) {
                this.openModal(event);
            }
        });
    },
    beforeDestroy() {
        Bus.$off('openBundleCalendarDateModal');
    },
};
</script>

<style scoped>
.event-name {
    margin-left: 0.5rem;
}
</style>
